import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=182e1396&scoped=true"
var script = {}
import style0 from "./fotter.vue?vue&type=style&index=0&id=182e1396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e1396",
  null
  
)

export default component.exports